import { useEffect, useState } from 'react';
import styled from 'styled-components';

// Material UI
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

// Services
import { postDocument } from '../../../../redux/api/documents';
import SimpleLoading from '../../../common/SimpleLoading';

const DocumentRequirementsSign = (props) => {
    const { open, handleClose, documentTypeId, title } = props;
    const [loading, setLoading] = useState(false);

    const [dataPost, setDataPost] = useState(null);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        color: '#222222',
    };

    useEffect(() => {
        postFetchDocument();
    }, []);

    const postFetchDocument = async () => {
        try {
            setLoading(true);
            const response = await postDocument(documentTypeId);
            if (response) {
                setDataPost(response);
            } else {
                setDataPost(null);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalCustom
            open={open}
            onClose={() => {
                handleClose();
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <BoxCustom sx={style}>
                {loading ? (
                    <SimpleLoading />
                ) : (
                    <>
                        <h2>{title}</h2>
                        <PdfContainer>
                            {!!dataPost ? (
                                <Iframe src={dataPost}></Iframe>
                            ) : (
                                <p>Cargando documento</p>
                            )}
                        </PdfContainer>
                    </>
                )}
            </BoxCustom>
        </ModalCustom>
    );
};

export default DocumentRequirementsSign;

const ModalCustom = styled(Modal)``;

const BoxCustom = styled(Box)`
    border-radius: 20px !important;
    width: 55vw;
    height: 85vh;

    h2 {
        font-size: 1.2rem;
        color: #b31d15;
    }

    @media (max-width: 1000px) {
        width: 75vw;
    }
`;

const PdfContainer = styled.div`
    width: 100%;
    height: calc(100% - 3.5rem);
    margin-top: 2rem;
    overflow: hidden;
`;

const Iframe = styled.iframe`
    border: none;
    width: 100%;
    height: calc(100% + 6rem);
    margin-top: -7rem;

    @media (width <= 1800px) {
        height: calc(100% + 12rem);
        margin-top: -12rem;
    }

    @media (width <= 1400px) {
        height: calc(100% + 15rem);
        margin-top: -15rem;
    }

    @media (width <= 768px) {
        height: calc(100% + 20rem);
        margin-top: -20rem;
    }
`;
